import { motion } from 'framer-motion';
import { LESSON } from '@/constants/testIds';

const ArrayVisualization = ({ array, step, lessonId }) => {
  if (!array || array.length === 0) return null;

  const getCellStyle = (index) => {
    const baseStyle = "w-16 h-16 flex items-center justify-center border-2 rounded-md text-xl font-code relative";
    
    if (!step) return `${baseStyle} border-white/20 bg-[#1A1A20] text-white`;

    // Linear search highlighting
    if (lessonId === 'linear-search') {
      if (step.found && step.currentIndex === index) {
        return `${baseStyle} border-green-500 bg-green-500/20 text-green-400 shadow-[0_0_15px_rgba(34,197,94,0.5)]`;
      }
      if (step.highlight?.includes(index)) {
        return `${baseStyle} border-[#FFB800] bg-[#FFB800]/10 text-[#FFB800] shadow-[0_0_15px_rgba(255,184,0,0.5)]`;
      }
      if (step.currentIndex > index) {
        return `${baseStyle} border-[#007AFF]/50 bg-[#007AFF]/10 text-[#007AFF]/80`;
      }
    }

    // Product except self
    if (lessonId === 'product-except-self') {
      if (step.currentIndex === index) {
        return `${baseStyle} border-[#FFB800] bg-[#FFB800]/10 text-[#FFB800] shadow-[0_0_15px_rgba(255,184,0,0.5)]`;
      }
      if (step.phase === 'suffix' && index > step.currentIndex) {
        return `${baseStyle} border-[#007AFF]/50 bg-[#007AFF]/10 text-[#007AFF]`;
      }
      if (step.phase === 'prefix' && index < step.currentIndex) {
        return `${baseStyle} border-green-500/50 bg-green-500/10 text-green-400`;
      }
    }

    // First missing positive
    if (lessonId === 'first-missing-positive') {
      if (step.swap && (step.currentIndex === index || step.targetIndex === index)) {
        return `${baseStyle} border-[#FFB800] bg-[#FFB800]/10 text-[#FFB800] shadow-[0_0_15px_rgba(255,184,0,0.5)]`;
      }
      if (step.currentIndex === index) {
        return `${baseStyle} border-[#007AFF] bg-[#007AFF]/10 text-[#007AFF]`;
      }
      if (step.phase === 'finding') {
        const expectedValue = index + 1;
        if (array[index] === expectedValue) {
          return `${baseStyle} border-green-500/50 bg-green-500/10 text-green-400`;
        }
      }
    }

    return `${baseStyle} border-white/20 bg-[#1A1A20] text-white`;
  };

  return (
    <div className="flex flex-wrap gap-3 justify-center items-center">
      {array.map((value, index) => (
        <motion.div
          key={index}
          data-testid={LESSON.arrayCell(index)}
          className={getCellStyle(index)}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3, delay: index * 0.05 }}
        >
          <div className="absolute -top-5 text-[10px] text-[#71717A] font-code">
            {index}
          </div>
          <div>{value}</div>
        </motion.div>
      ))}
    </div>
  );
};

export default ArrayVisualization;
